import { format, parseISO, startOfWeek, addDays, differenceInDays, isValid } from "date-fns";
// T-508 — Presenting mode. Only the MONEY formatters mask; dates, percentages
// and counts are untouched. Export/PDF paths have their own formatters and do
// not import from here, so a generated document always carries real numbers.
import { maskMoney } from "./presenting";

export const fmtDate     = (iso: string | Date | null) => iso ? format(typeof iso === "string" ? parseISO(iso) : iso, "dd MMM yyyy") : "";
export const fmtDateTime = (iso: string | Date | null) => iso ? format(typeof iso === "string" ? parseISO(iso) : iso, "dd MMM yyyy · HH:mm") : "";
export const fmtDayShort = (iso: string | Date)        => format(typeof iso === "string" ? parseISO(iso) : iso, "EEE");
export const fmtMoney    = (amount: number | null | undefined) => amount == null ? "—" : maskMoney(`$${amount.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const fmtMoneyK   = (amount: number | null | undefined) => amount == null ? "—" : maskMoney(`$${(amount / 1000).toFixed(1)}k`);
export const fmtPct      = (v: number | null | undefined) => v == null ? "—" : `${v.toFixed(1)}%`;

// Monday of the week containing `d`, as a YYYY-MM-DD string
export function mondayOf(d: Date = new Date()): string {
  return format(startOfWeek(d, { weekStartsOn: 1 }), "yyyy-MM-dd");
}

export function weekDates(mondayIso: string): string[] {
  const m = parseISO(mondayIso);
  if (!isValid(m)) return [];
  return Array.from({ length: 7 }, (_, i) => format(addDays(m, i), "yyyy-MM-dd"));
}

export function daysFromNow(iso: string | null): number | null {
  if (!iso) return null;
  const d = parseISO(iso);
  if (!isValid(d)) return null;
  return differenceInDays(d, new Date());
}

export function urgencyFromDays(days: number | null): "expired" | "critical" | "warning" | "notice" | "ok" {
  if (days == null) return "ok";
  if (days < 0)   return "expired";
  if (days <= 7)  return "critical";
  if (days <= 30) return "warning";
  if (days <= 60) return "notice";
  return "ok";
}
